import axios from "axios";
import axiosInstance, { API_BASE_URL } from "../../routes/axiosConfig";

export const getPublicUrl = (token) =>
  `${window.location.origin}/os/public/${token}`;

export const getExecutionImageUrl = (url) =>
  url?.startsWith("http") ? url : `${API_BASE_URL}${url}`;

export const isVideoMedia = (item) =>
  item?.contentType?.startsWith("video/") ||
  /\.(mp4|mov|webm|mkv|avi|m4v)$/i.test(item?.originalFileName || "");

export const getExecutionByServiceOrderId = async (serviceOrderId) => {
  const response = await axiosInstance.get(
    `/serviceOrder/${serviceOrderId}/execution`
  );
  if (response.status === 204 || !response.data) {
    return null;
  }
  return response.data;
};

// Sem Authorization: evita 401/redirect quando o JWT da sessão está expirado
export const getExecutionByToken = async (token) => {
  const response = await axios.get(
    `${API_BASE_URL}/public/service-order/${token}`
  );
  return response.data;
};

export const saveExecution = async ({
  serviceOrderId,
  executionSummary,
  executionNotes = "",
}) => {
  const response = await axiosInstance.post(
    `/serviceOrder/${serviceOrderId}/execution`,
    {
      executionSummary,
      executionNotes,
    }
  );
  return response.data;
};

export const uploadExecutionImages = async (serviceOrderId, files) => {
  const formData = new FormData();
  files.forEach((file) => formData.append("images", file));

  const response = await axiosInstance.post(
    `/serviceOrder/${serviceOrderId}/execution/images`,
    formData
  );
  return response.data;
};
